import { HubConnectionBuilder, LogLevel } from "@microsoft/signalr";
import { useEffect, useRef, useState, useCallback } from "react";
import UserService from "../UserService";

export function useMessageConsumer(vhost) {
    const connectionRef = useRef(null);
    const [isConnected, setIsConnected] = useState(false);
    const [message, setMessage] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!vhost) return;

        // remove the /SD from the api url
        let baseURL = process.env.REACT_APP_API_URL;
        let signalRUrl = baseURL + `/hubs/message-controller?vhost=${vhost}`;

        const connection = new HubConnectionBuilder()
            .withUrl(signalRUrl,{
                accessTokenFactory: async () => {
                    await UserService.updateToken(() => Promise.resolve());
                    return UserService.getToken();
                }
            })
            .withAutomaticReconnect()
            .configureLogging(LogLevel.Information)
            .build();

        connection.on("MessageReceived", (msg) => setMessage(msg));
        connection.on("AckSuccess", () => setMessage(null));
        connection.on("RequeueSuccess", () => setMessage(null));
        connection.on("MoveSuccess", () => setMessage(null));
        connection.on("Error", (err) => setError(err));

        connection.onreconnecting(() => setIsConnected(false));
        connection.onreconnected(() => setIsConnected(true));
        connection.onclose(() => setIsConnected(false));

        connection.start()
            .then(() => setIsConnected(true))
            .catch((err) => setError(err.toString()));

        connectionRef.current = connection;

        return () => {
            connection.stop();
        };
    }, [vhost]);

    const startConsuming = useCallback((queueName) => {
        return connectionRef.current?.invoke("StartConsuming", queueName);
    }, []);

    const ack = useCallback(() => {
        return connectionRef.current?.invoke("Ack");
    }, []);

    const requeue = useCallback(() => {
        return connectionRef.current?.invoke("Requeue");
    }, []);

    const moveMessage = useCallback((queueName) => {
        return connectionRef.current?.invoke("MoveMessage", queueName);
    }, []);

    return { isConnected, message, error, startConsuming, ack, requeue, moveMessage };
}